import { defineMessages } from 'react-intl';

export default defineMessages({
    quoteX: {
        id: 'ml.quoteandbind.pup.policySummary.Quote #',
        defaultMessage: 'Quote #: {quoteId}'
    },
    watercraftOperatorName: {
        id: 'ml.quoteandbind.pup.policySummary.drivers.NAME',
        defaultMessage: 'NAME'
    },
    watercraftOperatorGender: {
        id: 'ml.quoteandbind.pup.policySummary.drivers.GENDER',
        defaultMessage: 'GENDER'
    },
    watercraftOperatorDateOfBirth: {
        id: 'ml.quoteandbind.pup.policySummary.drivers.DATE OF BIRTH',
        defaultMessage: 'DATE OF BIRTH'
    },
    watercraftOperatorMaritalStatus: {
        id: 'ml.quoteandbind.pup.policySummary.drivers.MARITAL STATUS',
        defaultMessage: 'MARITAL STATUS'
    },
    watercraftOperators: {
        id: 'ml.quoteandbind.pup.policySummary.drivers.Watercraft Operators',
        defaultMessage: 'Watercraft Operators'
    },
    summaryExposures: {
        id: 'ml.quoteandbind.pup.policySummary.Exposures',
        defaultMessage: 'Exposures'
    },
    vehiclesAndBoats: {
        id: 'ml.quoteandbind.pup.policySummary.Vehicles and Boats',
        defaultMessage: 'Vehicles and Boats'
    },
    summaryProperties: {
        id: 'ml.quoteandbind.pup.policySummary.Properties',
        defaultMessage: 'Properties'
    },
    summaryCoverages: {
        id: 'ml.quoteandbind.pup.policySummary.Coverages',
        defaultMessage: 'Coverages'
    },
    summaryEditCoverages: {
        id: 'ml.quoteandbind.pup.policySummary.EDIT COVERAGES',
        defaultMessage: 'EDIT COVERAGES'
    },
    summaryAdditionalCoverages: {
        id: 'ml.quoteandbind.pup.policySummary.Additional coverages',
        defaultMessage: 'Additional coverages'
    },
    underlyingInsuranceHeader: {
        id: 'ml.quoteandbind.pup.policySummary.Required minimum underlying insurance',
        defaultMessage: 'Required minimum underlying insurance'
    },
    gpaUnderlyingInsuranceHeader: {
        id: 'ml.quoteandbind.pup.policySummary.gpa.Required Minimum Underlying Insurance',
        defaultMessage: 'Required Minimum Underlying Insurance'
    },
    underlyingPolicyType: {
        id: 'ml.quoteandbind.pup.policySummary.underlyingInsurance.UNDERLYING POLICY TYPE',
        defaultMessage: 'UNDERLYING POLICY TYPE'
    },
    underlyingPolicyLimit: {
        id: 'ml.quoteandbind.pup.policySummary.underlyingInsurance.EACH PERSON / EACH OCCURENCE OR SINGLE LIMIT',
        defaultMessage: 'EACH PERSON / EACH OCCURENCE OR SINGLE LIMIT'
    },
    csl: {
        id: 'ml.quoteandbind.pup.policySummary.underlyingInsurance.CSL',
        defaultMessage: 'CSL'
    },
    policyX: {
        id: 'ml.quoteandbind.pup.policySummary.Policy #',
        defaultMessage: 'Policy #{policyId}'
    },
    changeEffectiveDate: {
        id: 'ml.quoteandbind.pup.policySummary.Changes effective x',
        defaultMessage: 'Changes effective {date}'
    },
    changeConfirmationText: {
        id: 'ml.quoteandbind.pup.policySummary.Below are your changes. Below are your changes. Confirm what is listed below is correct.',
        defaultMessage: 'Below are your changes. Confirm what is listed below is correct.'
    },
    editCoverages: {
        id: 'ml.quoteandbind.pup.policySummary.Edit Coverages',
        defaultMessage: 'Edit Coverages'
    },
    insuranceSummaryText: {
        id: 'ml.quoteandbind.pup.policySummary.This summary of insurance coverage is issued as a matter of information only and confers no rights upon the holder. This summary does not amend, extend, or alter the coverage, terms, exclusions or conditions afforded by the policy referenced herein.',
        defaultMessage: 'This summary of insurance coverage is issued as a matter of information only and confers no rights upon the holder. This summary does not amend, extend, or alter the coverage, terms, exclusions or conditions afforded by the policy referenced herein.'
    }
});
